import { Box } from '@jfs/ui-new'
import { DropdownOptimised } from '../../../comps/DropdownNew'
import { DropdownTypes } from '../../../comps/DropdownNew/types'

const searchFiltersData = [
  { id: '1', value: 'Single Payout' },
  { id: '2', value: 'Bulk Payout' },
]

const CreatePayout = ({ setSelectedItem, valueSelected }: any) => {
  const handleKeyChange = (value: string) => {
    setSelectedItem && setSelectedItem(value)
  }
  return (
    <Box bg={'WHITE'}>
      <Box flexDirection="row">
        <DropdownOptimised
          placeHolder={'+ Create Payout'}
          type={DropdownTypes.ADD_BENEFICIARY}
          data={searchFiltersData}
          value={valueSelected}
          labelColor={'BLUE'}
          titleColor={'WHITE'}
          onChange={handleKeyChange}
          chevronColor={'WHITE'}
        />
      </Box>
    </Box>
  )
}

export { CreatePayout }
